
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_sdha6_1ez8h_141",
  "handle-size-normal": "awsui_handle-size-normal_sdha6_1ez8h_149",
  "handle-size-small": "awsui_handle-size-small_sdha6_1ez8h_153",
  "handle-drag-indicator": "awsui_handle-drag-indicator_sdha6_1ez8h_156",
  "handle-disabled": "awsui_handle-disabled_sdha6_1ez8h_156",
  "active": "awsui_active_sdha6_1ez8h_159",
  "handle-resize-area": "awsui_handle-resize-area_sdha6_1ez8h_162",
  "handle-resize-horizontal": "awsui_handle-resize-horizontal_sdha6_1ez8h_182",
  "handle-resize-vertical": "awsui_handle-resize-vertical_sdha6_1ez8h_185",
  "hide-focus": "awsui_hide-focus_sdha6_1ez8h_195",
  "resize-icon": "awsui_resize-icon_sdha6_1ez8h_218",
  "resize-icon-vertical": "awsui_resize-icon-vertical_sdha6_1ez8h_224",
  "resize-icon-horizontal": "awsui_resize-icon-horizontal_sdha6_1ez8h_228",
  "prevent-pointer": "awsui_prevent-pointer_sdha6_1ez8h_232"
};
  